import { render, staticRenderFns } from "./CsoSankeyChart.vue?vue&type=template&id=37a459ae&scoped=true"
import script from "./CsoSankeyChart.vue?vue&type=script&lang=js"
export * from "./CsoSankeyChart.vue?vue&type=script&lang=js"
import style0 from "./CsoSankeyChart.vue?vue&type=style&index=0&id=37a459ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a459ae",
  null
  
)

export default component.exports